import React from 'react'
import '../../../components/Models/Styles/PoolGrid.css';
import Flyer from '../../../components/Files-PDF/Flyers/ATCAN Royal Flyer OCT2024.pdf';
function RangeFlyer() {
  return (
    <div>
      <div className="rante-flyer"><a href={Flyer} target='blank'>Range Flyer</a></div>
    </div>
  )
}

export default RangeFlyer;